// extracted by mini-css-extract-plugin
export default {"tooltip":"_X-z","arrow":"aY-z"};